import { render, staticRenderFns } from "./CalendarSlot.vue?vue&type=template&id=545d4d16"
import script from "./CalendarSlot.vue?vue&type=script&lang=js"
export * from "./CalendarSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports